import { useEffect, useMemo, useRef } from 'react'
import type { Project } from '../types/api'

export function projectMention(value: string): { query: string; start: number } | undefined {
  const match = value.match(/(^|\s)@([^\s@]*)$/)
  if (!match || match.index === undefined) return undefined
  return { query: match[2], start: match.index + match[1].length }
}

export function removeProjectMention(value: string): string {
  const mention = projectMention(value)
  if (!mention) return value
  return value.slice(0, mention.start)
}

interface Props {
  open: boolean
  projects: Project[]
  loading?: boolean
  selectedProjectId?: string
  search: string
  onSearchChange: (value: string) => void
  onClose: () => void
  onSelect: (project: Project) => void
}

export function ProjectContextDrawer({ open, projects, loading = false, selectedProjectId, search, onSearchChange, onClose, onSelect }: Props) {
  const searchRef = useRef<HTMLInputElement>(null)
  const filteredProjects = useMemo(() => {
    const query = search.trim().toLocaleLowerCase()
    if (!query) return projects
    return projects.filter(project => `${project.title} ${project.description || ''}`.toLocaleLowerCase().includes(query))
  }, [projects, search])

  useEffect(() => {
    if (open) window.setTimeout(() => searchRef.current?.focus(), 0)
  }, [open])

  if (!open) return null

  return <aside className="project-context-drawer" role="dialog" aria-modal="false" aria-label="添加项目上下文">
    <header className="project-context-drawer-head">
      <div><strong>添加项目</strong><small>选择项目，或在输入框输入 @</small></div>
      <button type="button" className="project-context-drawer-close" onClick={onClose} aria-label="关闭项目抽屉"><i className="ri-close-line" /></button>
    </header>
    <label className="project-context-search"><i className="ri-search-line" aria-hidden="true" /><input ref={searchRef} value={search} onChange={event => onSearchChange(event.target.value)} placeholder="搜索项目…" aria-label="搜索项目" /></label>
    <div className="project-context-drawer-list">
      {loading ? <div className="project-context-drawer-empty">正在读取项目…</div> : filteredProjects.length ? filteredProjects.map(project => <button type="button" className={`project-context-drawer-item ${project.project_id === selectedProjectId ? 'active' : ''}`} key={project.project_id} onClick={() => onSelect(project)}>
        <i className="ri-folder-3-line" aria-hidden="true" />
        <span><b>{project.title}</b><small>{project.description || '项目上下文'}</small></span>
        {project.project_id === selectedProjectId && <i className="ri-check-line project-context-drawer-check" aria-label="已添加" />}
      </button>) : <div className="project-context-drawer-empty">{projects.length ? '没有匹配的项目' : '暂无项目，请先在创作工坊新建项目。'}</div>}
    </div>
  </aside>
}
